import { FC, PropsWithChildren, createContext, useCallback, useMemo, useState } from 'react';
import { DocumentSearchTarget } from '@models/searchable';

export type DecisionSearchScope = 'analysis' | 'decision';

interface DecisionSearchContextValue {
    analysisTarget?: DocumentSearchTarget;
    hasFocusedAnalysis: boolean;
    scope: DecisionSearchScope;
    setAnalysisTarget: (target?: DocumentSearchTarget) => void;
    setScope: (scope: DecisionSearchScope) => void;
}

export const DecisionSearchContext = createContext<DecisionSearchContextValue | null>(null);

interface DecisionSearchProviderProps extends PropsWithChildren {
    focusedAnalysisId?: string;
}

const DecisionSearchProvider: FC<DecisionSearchProviderProps> = ({
    children,
    focusedAnalysisId,
}) => {
    const [analysisTarget, setAnalysisTargetState] = useState<DocumentSearchTarget>();
    const [scope, setScope] = useState<DecisionSearchScope>(
        focusedAnalysisId ? 'analysis' : 'decision',
    );

    const setAnalysisTarget = useCallback((target?: DocumentSearchTarget) => {
        setAnalysisTargetState(target);
    }, []);

    const value = useMemo(
        () => ({
            analysisTarget,
            hasFocusedAnalysis: Boolean(focusedAnalysisId),
            scope,
            setAnalysisTarget,
            setScope,
        }),
        [analysisTarget, focusedAnalysisId, scope, setAnalysisTarget],
    );

    return (
        <DecisionSearchContext.Provider value={value}>{children}</DecisionSearchContext.Provider>
    );
};

export default DecisionSearchProvider;
